import React, { useEffect, useState } from "react";
import { WizardProvider } from "../wizard/WizardContext";
import WizardStep from "../wizard/WizardStep";
import WizardTopHeader from "../wizard/Topheader";
import FormField from "../wizard/FormField";
import { MenuItem } from "@mui/material";
import { PermisionDenied } from "views/pages/manage/common/commonComponents";


const checkModuleEnabled = (businessAreaDispVals = [], buList = []) => {
  return buList.some(bu => businessAreaDispVals.includes(bu?.label));
};
export default function DynamicWizard({ config = {}, recordId, onFinished , enabledOnList =[], checkPermission = false, enabledForAllBUs = false, ...props }) {
  // const stepsConfig = Array.isArray(config.steps) ? config.steps : [];
  const dropdownApi = config?.fetchDropdown;
  const [searchWizard, setSearchWizard] = useState(config.searchWizard);

  const [initial, setInitial] = useState(config.initialValues || {});
  const [loading, setLoading] = useState(!!recordId);
  const [dropdowns, setDropdowns] = useState({ loading: false, data: {} });

  let isEnabled = (enabledForAllBUs ||  dropdowns?.data?.businessAres?.length>0 && checkModuleEnabled(enabledOnList, dropdowns?.data?.businessAres));
  const [stepsConfig, setStepsConfig] = useState(config.steps || []);

  useEffect(() => {
    if (!recordId) {
      setLoading(false);
      return;
    }
  }, [recordId]);

  useEffect(() => {
    setDropdowns((prev) => ({ ...prev, loading: true }));
    const fetchDropdown = async () => {
      const dropdown = await dropdownApi();
      setDropdowns({ loading: false, data: dropdown });
    };
    if (dropdownApi) {
      fetchDropdown();
      return;
    }
  }, [dropdownApi]);

  if( checkPermission && !dropdowns?.loading &&  !isEnabled)
   return <PermisionDenied/>

  return (
    <WizardProvider
      steps={stepsConfig?.map((s) => s.label)}
      initialValues={initial}
      validationSchema={config.validationSchema}
      dropdowns={dropdowns}
      searchWizard={searchWizard}
      setSearchWizard={setSearchWizard}
      onSubmit={(values) => {}}
      setStepsConfig={setStepsConfig}
      stepsConfig={stepsConfig}
      {...props}
    >
      {searchWizard?.isShow ? (
        React.createElement(searchWizard.component)
      ) : (
        <>
          {!config.topHeader ? (
            <WizardTopHeader
              backIconClickHandler={() =>
                config?.backIconClickHandler
                  ? config.backIconClickHandler()
                  : setSearchWizard((prev) => ({ ...prev, isShow: true }))
              }
              label={config.heading}
            />
          ) : (
            React.createElement(config.topHeader, {
              backIconClickHandler: () =>
                setSearchWizard((prev) => ({ ...prev, isShow: true })),
            })
          )}

          {stepsConfig.map((step, idx) => (
            <WizardStep
              key={step.id || idx}
              index={idx}
              isStepperNavigationAllowed={config?.isStepperNavigationAllowed}
            >
              {step.component
                ? React.createElement(step.component)
                : (step.fields || []).map((f) => (
                    <FormField
                      key={f.name}
                      name={f.name}
                      label={f.label}
                      type={f.type}
                      options={f.options}
                      fullWidth
                      margin="normal"
                    >
                      {f.options?.map((o) => (
                        <MenuItem key={o} value={o}>
                          {o}
                        </MenuItem>
                      ))}
                    </FormField>
                  ))}
            </WizardStep>
          ))}
        </>
      )}
    </WizardProvider>
  );
}
